export enum NaturezaOperacaoErrorCodeEnum {
    SeedPendente = 1,
}
